import React from "react";

const Footer = () => {
  return (
    <div class="footer">
      Copyright © 2025. All rights reserved. | Powered by <a href="https://milosautomation.com/" target='_blank' class="text-primary">Milos Automation</a>
    </div>
  );
};

export default Footer;